import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { Loading,Message } from 'element-ui'
import goods from '../utils/goods'

import $ from 'jquery'
import {multiply} from '../utils/tool'
Vue.use(Vuex)

export default new Vuex.Store({
//配置
plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths:['goods_cart','goods_cart_count','goods_cart_total','goods_cart_drawer','buyNow']
   })],

  state: {
    
    goods_cart: [],
    goods_cart_count:0,
    goods_cart_total:0,
    goods_cart_drawer:false,
    goodsList: [],
    buyNow:[],
    //这里放全局参数
  },

  mutations: {
    //这里是set方法
    setGoods_cart(state,value) {
        state.goods_cart = value
        
    },
    setGoods_cart_count(state,value) {     
        state.goods_cart_count = value
    },
    setGoods_cart_drawer(state,value) {
        state.goods_cart_drawer = value
    },
    setGoods_cart_total(state,value){
        state.goods_cart_total = value
    },
    setGoods(state,value) {
        state.goodsList = value
    },
    setBuyNow(state,value){
        state.buyNow = value
    }
    
  },



  actions: {
    // 处理state的方法体
    // 购物车商品 数量修改
    updateItemCount({ state, commit } , { type, item, index }){
        console.log('context',state,type,item,index)
        let options = {
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }
       let loadingInstance = Loading.service(options)
       new Promise((resolve,reject) => {
        setTimeout(() => {
            loadingInstance.close()
            resolve()
        }, 1500);
        
       
       }).then(()=>{
        let goodsCart = state.goods_cart
        goodsCart.map((v,idx)=>{
            if(index == idx){
                if(type == 'cut'){
                    v.count--
                    if(v.count == 0){
                        goodsCart.splice(index,1)
                    }            
                }
                if(type == 'add'){
                    v.count++
                }
                if(type == 'delete'){
                    goodsCart.splice(index,1)
                }
            }
            v.total = v.count * Number(v.amount)
            // sessionStorage.setItem('goods_cart',JSON.stringify(goodsCart))
            commit('setGoods_cart',goodsCart)
            let count = 0
            let total = 0
            state.goods_cart.map(v=>{
                count = Number(v.count) + count
                total = Number(v.total) + total
            })
            commit('setGoods_cart_count', count)
            commit('setGoods_cart_total',total.toFixed(2))
        })
    })
        
        
        
    },
    // 商品列表
    getGoods({commit},{name,size,searchName}){
        let options = {
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }
       let loadingInstance = Loading.service(options)
       new Promise((resolve,reject) => {
        setTimeout(() => {
            loadingInstance.close()
            
            console.log('goods',goods,name)
            let result = goods.data
                .filter(v => v.categories == name)
                .map(v => {
                    v.frontImage = v.images[0].src
                    v.backImage = v.images[1].src
                    v.name = v.title
                    return v
                })
            
            // console.log('result',result)
            resolve(result)
        }, 1500);
       }).then(res=>{
        commit('setGoods',res)
       })
    },
    getSearchGoods({commit},{searchName}){
        let options = {
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }
        let loadingInstance = Loading.service(options)
        new Promise((resolve,reject) => {
            setTimeout(() => {
                loadingInstance.close()
                let result = goods.data
                .filter(v => v.title.toLowerCase().includes(searchName.toLowerCase()) || v.description.toLowerCase().includes(searchName.toLowerCase()) || v.categories.toLowerCase().includes(searchName.toLowerCase()) )
                .map(v => {
                    v.frontImage = v.images[0].src
                    v.backImage = v.images[1].src
                    v.name = v.title
                    return v
                })
                resolve(result)
            }, 1500);
        }).then((res)=>{
            commit('setGoods',res)
        })
    },
    addCart({state,commit},{item}){
        let options = {
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }
       let loadingInstance = Loading.service(options)
         new Promise((resolve, reject)=>{
             setTimeout(() => {
                loadingInstance.close()
                resolve()
            }, 1500);
        }).then(()=>{
            
            let goodsCart = state.goods_cart
            let product = item
            let color_name = product.color
            let size_name = product.size
            
            
            let is_find = goodsCart.findIndex((v, index) => {
               
                return v.id == product.id  && v.color_name == color_name && v.size == size_name
            })
            console.log('goodsCart',product.id,product,is_find)
            if(is_find > -1){
                let count = Number( goodsCart[is_find].count) + 1
                let amount = Number(goodsCart[is_find].amount)
                let total = (count * amount).toFixed(2)
                goodsCart[is_find].total = total
                goodsCart[is_find].count = count
                
                commit('setGoods_cart',goodsCart)
                commit('setGoods_cart_drawer',true)

            }else{
                let count = 1
                let amount = Number(product.amount)
                let total = (count * amount).toFixed(2)
                product.color_name = color_name
                product.size_name = size_name
                product.total = total
                product.count = count
               
                goodsCart.push(product)
                commit('setGoods_cart',goodsCart)
                commit('setGoods_cart_drawer',true)
            }
            let count = 0
            let total = 0
            state.goods_cart.map(v=>{
                count = Number(v.count) + count
                total = Number(v.total) + total
            })
            commit('setGoods_cart_count', count)
            commit('setGoods_cart_total',total.toFixed(2))
        })
    },
    // 导出购物车数据
    exportCartData({state},{name}) {
        let goodsCart = goods.data[name]
        
        // 准备导出数据
        let exportData = []
        let csvContent = '商品名字,单价,尺码,颜色\n'
        
        goodsCart.forEach((item) => {
            let id = item.product_listing_result_id
            item.variant_displays.map(v=>{  
                v.amount = multiply(v.original_price)
                if(id == '552a4573-fd6f-43a4-a903-8fd9488f46c5'){
                    v.amount = '25.8'
                }
                if(id == '548ac16e-c8bd-43a0-b0cb-1e5edefc79be'){
                    v.amount = '25.5'
                }
                let row = {
                    name: v.title || '',
                    amount: v.amount || '',
                    size: v.size || '',
                    color_name: v.color_name || ''
                }
                exportData.push(row)
                // 生成CSV行
               csvContent += `"${row.name}","${row.amount}","${row.size}","${row.color_name}"\n`
            })
            
            
            
        })
        
        // 创建Blob对象
        let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        let link = document.createElement('a')
        let url = URL.createObjectURL(blob)
        
        // 生成文件名（当前时间戳）
        let timestamp = new Date().getTime()
        link.setAttribute('href', url)
        link.setAttribute('download', `购物车数据_${timestamp}.csv`)
        link.style.visibility = 'hidden'
        
        // 触发下载
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        Message.success('数据已导出')
        return exportData
    }
  },

  modules: {

   //这里是我自己理解的是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里

  }

})



// WEBPACK FOOTER //
// ./src/store/store.js